<template>
  <div style="padding: 15px;">
    <!-- Modal ve diğer UI kısmı burada -->
    <div class="row">
      <div class="col">
        <div class="float-start">
          <div v-if="!contractDisplay">
            <h4>Sözleşmeler</h4>
          </div>
          <div v-if="contractDisplay">
            <h4>Sözleşme Ekle/Düzenle</h4>
          </div>
        </div>
        <div class="float-end">
          <button type="button" v-if="!contractDisplay" class="btn btn-success" @click="newContract">Yeni Sözleşme Ekle</button>
        </div>
      </div>
    </div>

    <!-- ARAMA VE İŞLEM BUTONLARI BÖLÜMÜ -->
    <div class="row gy-2 align-items-center" style="margin-top: 20px" v-if="!contractDisplay">
      <div class="col-sm-12 col-md-3">
        <input type="text" class="form-control" placeholder="Sözleşme adına göre ara..." v-model="searchQuery">
      </div>
      <div class="col-sm-12 col-md-2">
        <select class="form-select" v-model="statusFilter">
          <option value="">Tüm Durumlar</option>
          <option value="active">Aktif</option>
          <option value="passive">Pasif</option>
        </select>
      </div>
      <div class="col-sm-12 col-md-7 text-md-end">

        <!-- YENİ: Sütun Yönetimi için Modal'ı tetikleyen Filtre butonu -->
        <button type="button" class="btn btn-secondary me-2" data-bs-toggle="modal" data-bs-target="#filterColumnsModal">
          Filtre
        </button>

        <button type="button" class="btn btn-info text-white" @click="exportToExcel">Excel'e Aktar</button>
      </div>
    </div>

    <!-- YENİ: Sütun Filtreleme Modalı -->
    <div class="modal fade" id="filterColumnsModal" tabindex="-1" aria-labelledby="filterColumnsModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="filterColumnsModalLabel">Gösterilecek Sütunları Seçin</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <!-- tableHeaders dizisindeki her bir sütun için bir checkbox oluştur -->
            <div class="form-check" v-for="header in tableHeaders" :key="header.key">
              <!-- 'actions' sütununu filtreleme dışında tutabiliriz -->
              <template v-if="header.key !== 'actions'">
                <input class="form-check-input" type="checkbox" v-model="header.visible" :id="'check-' + header.key">
                <label class="form-check-label" :for="'check-' + header.key">
                  {{ header.text }}
                </label>
              </template>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Kapat</button>
          </div>
        </div>
      </div>
    </div>


    <div class="row" style="margin-top: 10px">
      <div class="table-responsive" v-if="!contractDisplay">
        <table class="table align-middle">
          <thead>
          <tr>
            <!-- Başlıklar dinamik ve sıralanabilir -->
            <th v-for="header in visibleHeaders" :key="header.key" @click="header.sortable ? sortBy(header.key) : null" :class="{ 'sortable-header': header.sortable }">
              <b>{{ header.text }}</b>
              <span v-if="sortKey === header.key">
                  <i v-if="sortDirection === 'asc'">▲</i>
                  <i v-else>▼</i>
                </span>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="val in paginatedContracts" :key="val.id">
            <td v-for="header in visibleHeaders" :key="header.key">
              <template v-if="header.key === 'contractname'">
                <router-link :to="{ name: 'contractDetails', params: { id: val.id } }">
                  {{ val.contractname }}
                </router-link>
              </template>
              <template v-else-if="header.key === 'contractdate' || header.key === 'renewalcontractdate'">
                {{ new Date(val[header.key]).toLocaleDateString() }}
              </template>
              <template v-else-if="header.key === 'contractprice'">
                {{ formatCurrency(val.contractprice) }}
              </template>
              <template v-else-if="header.key === 'status'">
                  <span :class="getStatusClass(val)">
                    {{ getStatusText(val) }}
                  </span>
              </template>
              <template v-else-if="header.key === 'actions'">
                <div class="actions-buttons">
                  <button type="button"
                          v-if="!getDeletedAt(val)"
                          class="btn btn-danger btn-sm me-1"
                          data-bs-toggle="modal"
                          data-bs-target="#deleteContractModal"
                          @click="tempDeleteId = val.id">Pasife Al</button>
                  <button type="button" class="btn btn-secondary btn-sm" @click="editContract(val.id)">Düzenle</button>
                </div>
              </template>
              <template v-else>
                {{ val[header.key] }}
              </template>
            </td>
          </tr>
          <tr v-if="filteredAndSortedContracts.length === 0">
            <td :colspan="visibleHeaders.length" class="text-center">Arama kriterlerine uygun sözleşme bulunamadı.</td>
          </tr>
          </tbody>
        </table>

        <div class="pagination" v-if="filteredAndSortedContracts.length">
          <button @click="prevPage" :disabled="currentPage === 1">
            Önceki
          </button>
          <span>Sayfa {{ currentPage }} / {{ totalPages }}</span>
          <button @click="nextPage" :disabled="currentPage === totalPages">
            Sonraki
          </button>
        </div>

        <!-- Pasife Alma Onayı Modal -->
        <div class="modal fade" id="deleteContractModal" tabindex="-1" aria-labelledby="deleteContractModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="deleteContractModalLabel">Pasife Alma Onayı</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">Bu sözleşmeyi pasife almak istediğinizden emin misiniz?</div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">İptal</button>
                <button type="button" class="btn btn-danger" @click="confirmDelete">Evet, Pasife Al</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- SÖZLEŞME EKLEME/DÜZENLEME FORMU (DEĞİŞİKLİK YOK) -->
    <div v-if="contractDisplay">
      <div class="page-list">
        <div v-for="page in pages" :key="page.value" @click="selectedPage = page" :class="{ active: selectedPage.pageName === page.pageName }" class="page-item">
          {{ page.visibleName }}
        </div>
      </div>
      <hr>

      <div v-if="selectedPage.pageName === 'contract'">
        <contract-fields-component :contractItems="contractItems"></contract-fields-component>
      </div>

      <div v-if="selectedPage.pageName === 'personal'">
        <personal-fields-component
            v-model:selectedPersonal="selectedPersonal"
            :contractId="contractId"
            :companyId="currentCompanyId || contractItems?.company?.id"
            :contractItems="contractItems"
            @personal-expense-updated="onPersonalExpenseUpdated"
            @contract-price-updated="onContractPriceUpdated"
        >
        </personal-fields-component>
      </div>


      <div v-if="selectedPage.pageName === 'projectProfitability'">
        <project-profitability-component :contractId="contractId"  :contractItems="contractItems"></project-profitability-component>
      </div>

      <div v-if="selectedPage.pageName === 'files'">
        <contract-file-upload :contractId="contractId"></contract-file-upload>
      </div>

      <br>

      <div v-if="selectedPage.pageName === 'contract'">
        <button
            type="button"
            class="btn btn-danger"
            @click="handleCancel"
            :disabled="isLoading">
          Vazgeç
        </button>
        <button
            type="button"
            class="btn btn-success"
            :disabled="!contractItems.company?.id || isLoading"
            :title="!contractItems.company?.id ? 'Lütfen önce bir firma seçiniz' : ''"
            @click="save">
          <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          {{ contractId ? 'Güncelle' : 'Kaydet' }}
        </button>

      </div>
      
      <!-- Yükleme Overlay -->
      <div v-if="isLoading" class="loading-overlay">
        <div class="loading-content">
          <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">Yükleniyor...</span>
          </div>
          <p class="mt-3">Güncelleniyor, lütfen bekleyiniz...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//  @ts-nocheck
import ContractFieldsComponent from "@/views/Contracts/ContractFieldsComponent.vue";
import PersonalFieldsComponent from "@/views/Contracts/PersonalFieldsComponent.vue";
import apiClient from "@/axios";
import ProjectProfitabilityComponent from "./ProjectProfitabilityComponent.vue";
import ContractFileUpload from "./ContractFileUpload.vue";
import * as XLSX from 'xlsx';

export default {
  name: "Profile",
  components: {ContractFileUpload, ProjectProfitabilityComponent, PersonalFieldsComponent, ContractFieldsComponent },
  data() {
    return {
      currentCompanyId: null,
      contractItems: {
        contractFields: {},
      },
      selectedPersonal: [],
      contractDisplay: false,
      contractsData: [],
      contractId: null,
      selectedPage: { value: 0, pageName: 'contract', visibleName: 'Sözleşme' },
      pages: [
        { value: 0, pageName: 'contract', visibleName: 'Sözleşme' },
        { value: 1, pageName: 'personal', visibleName: 'Personel' },
        { value: 2, pageName: 'projectProfitability', visibleName: 'Proje Karlılık' },
        { value: 3, pageName: 'files', visibleName: 'Dosyalar' },
      ],
      tempDeleteId: null,
      isLoading: false,

      searchQuery: '',
      statusFilter: '',
      sortKey: 'contractname',
      sortDirection: 'asc',
      currentPage: 1,
      itemsPerPage: 8,
      tableHeaders: [
        { key: 'contractname', text: 'Sözleşme Adı', visible: true, sortable: true },
        { key: 'contractnumber', text: 'Sözleşme Numarası', visible: true, sortable: false },
        { key: 'companyname', text: 'Firma', visible: true, sortable: false },
        { key: 'contracttime', text: 'Sözleşme Süre', visible: true, sortable: false },
        { key: 'contractdate', text: 'Sözleşme Tarihi', visible: true, sortable: false },
        { key: 'renewalcontractdate', text: 'Sözleşme Yenileme Tarihi', visible: true, sortable: false },
        { key: 'contractprice', text: 'Sözleşme Tutarı', visible: true, sortable: false },
        { key: 'osgbbranchname', text: 'OSGB Şubesi', visible: false },
        { key: 'customerrepresentativename', text: 'Müşteri Temsilcisi', visible: false },
        { key: 'status', text: 'Durum', visible: true, sortable: true },
        { key: 'actions', text: 'İşlemler', visible: true, sortable: false },
      ],
    };
  },
  computed: {
    visibleHeaders() {
      return this.tableHeaders.filter(h => h.visible);
    },
    filteredAndSortedContracts() {
      let filtered = [...this.contractsData];

      // Arama filtresi
      if (this.searchQuery) {
        const normalizedQuery = this.normalizeSearch(this.searchQuery);
        filtered = filtered.filter(contract =>
            this.normalizeSearch(contract.contractname).includes(normalizedQuery)
        );
      }

      // Durum filtresi - Artık deleted_at'e göre kontrol ediyoruz
      if (this.statusFilter) {
        filtered = filtered.filter(contract => {
          // deleted_at null ise aktif, null değilse pasif
          // Tüm olası alan isimlerini kontrol et (PostgreSQL bazen küçük harfle döner)
          const deletedAt = contract.deletedAt || contract.deleted_at || contract.deletedat || contract.contractDeletedAt;
          const isActive = !deletedAt;

          if (this.statusFilter === 'active') {
            return isActive;
          } else if (this.statusFilter === 'passive') {
            return !isActive;
          }
          return true;
        });
      }

      // Sıralama
      if (this.sortKey) {
        filtered.sort((a, b) => {
          let valA, valB;

          // Durum sütunu için özel sıralama - Artık deleted_at'e göre kontrol ediyoruz
          if (this.sortKey === 'status') {
            // Tüm olası alan isimlerini kontrol et (PostgreSQL bazen küçük harfle döner)
            const deletedAtA = a.deletedAt || a.deleted_at || a.deletedat || a.contractDeletedAt;
            const deletedAtB = b.deletedAt || b.deleted_at || b.deletedat || b.contractDeletedAt;
            valA = !deletedAtA ? 'Aktif' : 'Pasif';
            valB = !deletedAtB ? 'Aktif' : 'Pasif';
          } else {
            valA = a[this.sortKey];
            valB = b[this.sortKey];
          }

          if (valA == null) return 1;
          if (valB == null) return -1;
          if (typeof valA === 'string') valA = valA.toLowerCase();
          if (typeof valB === 'string') valB = valB.toLowerCase();

          let comparison = 0;
          if (valA > valB) {
            comparison = 1;
          } else if (valA < valB) {
            comparison = -1;
          }
          return this.sortDirection === 'asc' ? comparison : -comparison;
        });
      }
      return filtered;
    },
    totalPages() {
      const total = Math.ceil(this.filteredAndSortedContracts.length / this.itemsPerPage);
      return total > 0 ? total : 1;
    },
    paginatedContracts() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredAndSortedContracts.slice(start, start + this.itemsPerPage);
    },
    isFirstPage() {
      return this.selectedPage.value === 0;
    },
    isLastPage() {
      return this.selectedPage.value === this.pages.length - 1;
    }
  },
  created() {
    this.getContractList();
  },
  watch: {
    '$route'(to, from) {
      // Route değiştiğinde ve query parametresi varsa contractDisplay'i false yap
      if (to.query._t && this.contractDisplay) {
        this.contractDisplay = false;
        // Query parametresini temizle
        this.$router.replace({ path: to.path });
      }
    },
    'filteredAndSortedContracts'() {
      this.ensureCurrentPageInRange();
    },
    searchQuery() {
      this.resetPagination();
    },
    statusFilter() {
      this.resetPagination();
    }
  },
  methods: {
    normalizeSearch(value) {
      if (value === null || value === undefined) {
        return '';
      }
      return String(value).toLocaleLowerCase('tr-TR');
    },
    onPersonalExpenseUpdated() {
      // Personel gider güncellendiğinde sözleşme tutarını yeniden yükle
      this.getContractList();
    },
    onContractPriceUpdated(newPrice) {
      // Sözleşme tutarı güncellendiğinde contractItems'ı güncelle
      if (this.contractItems) {
        this.contractItems.contractPrice = newPrice;
      }
      // Dashboard'u da güncelle
      this.getContractList();
    },
    exportToExcel() {
      const dataToExport = this.filteredAndSortedContracts.map(contract => {
        const row = {};
        this.visibleHeaders.forEach(header => {
          if (header.key === 'actions') return;
          if (header.key === 'status') {
            row[header.text] = this.getStatusText(contract);
          } else if (header.key === 'contractdate' || header.key === 'renewalcontractdate') {
            row[header.text] = new Date(contract[header.key]).toLocaleDateString();
          } else if (header.key === 'contractprice') {
            row[header.text] = contract.contractprice;
          } else {
            row[header.text] = contract[header.key];
          }
        });
        return row;
      });
      if(dataToExport.length === 0) {
        alert("Dışa aktarılacak veri bulunamadı.");
        return;
      }
      const worksheet = XLSX.utils.json_to_sheet(dataToExport);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sözleşmeler');
      XLSX.writeFile(workbook, 'Sözleşmeler_Listesi.xlsx');
    },
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = key;
        this.sortDirection = 'asc';
      }
    },
    newContract() {
      this.contractDisplay = true;
      this.contractId = null;
      this.contractItems = {
        contractFields: {},
        company: null,
        contractNumber: '',
        contractName: '',
        contractDate: '',
        contractTime: null,
        renewalContractDate: '',
        stampDuty: 0,
        contractPrice: null,
        osgbBranchId: null,
        customerRepresentativeUserId: null
      };
      this.selectedPersonal = [];
      this.currentCompanyId = null;
      this.selectedPage = { value: 0, pageName: 'contract', visibleName: 'Sözleşme' };
    },
    getDeletedAt(contract) {
      // Backend zaten deletedAt olarak normalize ediyor
      if (!contract) return null;
      
      // Önce normalize edilmiş deletedAt'i kontrol et
      let deletedAt = contract.deletedAt;
      
      // Eğer normalize edilmemişse alternatif alanları kontrol et (fallback)
      if (deletedAt === undefined) {
        deletedAt = contract.deleted_at || contract.deletedat || contract.contractDeletedAt;
      }
      
      // null, undefined, veya boş string ise null döndür (aktif)
      // Değer varsa (tarih string'i) o değeri döndür (pasif)
      if (deletedAt === null || deletedAt === undefined || deletedAt === '') {
        return null;
      }
      
      return deletedAt;
    },
    getStatusText(contract) {
      // deleted_at null ise Aktif, dolu ise Pasif
      const deletedAt = this.getDeletedAt(contract);
      // deletedAt null veya undefined ise Aktif, değilse Pasif
      return (deletedAt === null || deletedAt === undefined || deletedAt === '') ? 'Aktif' : 'Pasif';
    },

    getStatusClass(contract) {
      // deleted_at null ise aktif, dolu ise pasif
      const deletedAt = this.getDeletedAt(contract);
      const isActive = (deletedAt === null || deletedAt === undefined || deletedAt === '');
      return {
        'status-active': isActive,
        'status-passive': !isActive
      };
    },
    handleCancel() {
      if (confirm('Kaydedilmemiş değişiklikleriniz kaybolacak. Devam etmek istiyor musunuz?')) {
        this.contractDisplay = false;
      }
    },
    mapContractFromBackend(data) {
      return {
        id: data.id,
        contractNumber: data.contractnumber,
        contractName: data.contractname,
        companyName: data.companyname,
        companyRegistrationNumber: data.companyregistrationnumber,
        company: {
          id: data.companyid
        },
        contractDate: this.formatDate(data.contractdate),
        contractTime: data.contracttime,
        renewalContractDate: this.formatDate(data.renewalcontractdate),
        stampDuty: data.stampduty,
        contractPrice: data.contractprice,
        osgbBranch: data.osgbbranchid ? { id: data.osgbbranchid } : null,
        customerRepresentativeUserId: data.customerrepresentativeuserid || null,
        contractFields: {}
      };
    },
    mapContractToBackend(data) {
      return {
        id: data.id,
        contractNumber: data.contractNumber,
        contractName: data.contractName,
        contractDate: this.toTimestamp(data.contractDate),
        contractTime: data.contractTime,
        renewalContractDate: this.toTimestamp(data.renewalContractDate),
        stampDuty: data.stampDuty,
        contractPrice: data.contractPrice,
        osgbBranch: { id: data.osgbBranchId },
        osgbBranchId: data.osgbBranchId,
        customerRepresentativeUserId: data.customerRepresentativeUserId,
        company: data.company
      };
    },
    toTimestamp(dateStr) {
      return dateStr ? new Date(dateStr).getTime() : null;
    },
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toISOString().split('T')[0];
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return '';
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY'
      }).format(value);
    },
    cancel() {
      this.contractDisplay = false;
    },
    confirmDelete() {
      if (!this.tempDeleteId) {
        return;
      }
      
      const contractIdToDelete = this.tempDeleteId;
      this.tempDeleteId = null; // Önce sıfırla ki tekrar tıklanmasın
      
      // Modal'ı hemen kapat
      this.closeDeleteModal();
      
      apiClient.delete(`/contract/${contractIdToDelete}`)
          .then(() => {
              // Liste yenileme işlemini biraz geciktir (backend'in güncellemesi için)
              setTimeout(() => {
                this.getContractList();
                // Liste yenilendikten sonra tekrar kontrol et ve Vue'nun reaktif sisteminin güncellemeyi algılaması için bekle
                this.$nextTick(() => {
                  setTimeout(() => {
                    const updatedContract = this.contractsData.find(c => c.id === contractIdToDelete);
                    if (updatedContract) {
                      const deletedAt = this.getDeletedAt(updatedContract);
                      const status = this.getStatusText(updatedContract);
                      console.log('Pasife alınan sözleşme kontrolü - ID:', contractIdToDelete);
                      console.log('  - deletedAt:', deletedAt);
                      console.log('  - deletedAt type:', typeof deletedAt);
                      console.log('  - deletedAt === null:', deletedAt === null);
                      console.log('  - Status:', status);
                      console.log('  - Sözleşme objesi:', updatedContract);
                      
                      // deletedAt null olmamalı (pasif olmalı)
                      if (deletedAt === null || deletedAt === undefined || deletedAt === '') {
                        console.warn('UYARI: Sözleşme pasife alındı ama deletedAt hala null görünüyor!');
                        // Eğer hala null ise, listeyi tekrar yenile
                        setTimeout(() => {
                          this.getContractList();
                        }, 500);
                      } else {
                        console.log('✓ Sözleşme başarıyla pasif olarak işaretlendi');
                        // Vue'nun reaktif sisteminin güncellemeyi algılaması için force update
                        this.$forceUpdate();
                      }
                    } else {
                      console.warn('UYARI: Pasife alınan sözleşme listede bulunamadı!');
                    }
                    alert('Sözleşme başarıyla pasife alındı');
                  }, 800);
                });
              }, 500);
          })
            .catch(error => {
              console.error('Pasife alma hatası:', error);
              alert('Sözleşme pasife alınırken bir hata oluştu: ' + (error.response?.data?.message || error.message));
              // Hata durumunda listeyi yenile
              this.getContractList();
            });
    },
    closeDeleteModal() {
      try {
        const modalElement = document.getElementById('deleteContractModal');
        
        // Bootstrap 5 modal kapatma
        if (window.bootstrap && window.bootstrap.Modal) {
          const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
          if (modalInstance) {
            modalInstance.hide();
            // Modal kapandıktan sonra backdrop'u temizle
            setTimeout(() => {
              this.cleanupModalBackdrop();
            }, 300);
            return;
          }
        }
        
        // Fallback: Modal'ı manuel olarak gizle
        if (modalElement) {
          modalElement.classList.remove('show');
          modalElement.style.display = 'none';
          modalElement.setAttribute('aria-hidden', 'true');
          modalElement.removeAttribute('aria-modal');
        }
        
        // Backdrop ve body temizliği
        this.cleanupModalBackdrop();
        
      } catch (e) {
        console.error('Modal kapatma hatası:', e);
        // Hata olsa bile temizliği yap
        this.cleanupModalBackdrop();
      }
    },
    cleanupModalBackdrop() {
      try {
        // Tüm backdrop'ları kaldır
        const backdrops = document.querySelectorAll('.modal-backdrop');
        backdrops.forEach(backdrop => {
          backdrop.remove();
        });
        
        // Body'den modal class'larını ve stillerini kaldır
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        
        // Eğer hala modal-open class'ı varsa zorla kaldır
        if (document.body.classList.contains('modal-open')) {
          document.body.classList.remove('modal-open');
        }
        
        // Body'nin tüm stillerini kontrol et
        if (document.body.style.overflow === 'hidden') {
          document.body.style.overflow = '';
        }
        
        // Tüm modal elementlerini kontrol et ve gizle
        const allModals = document.querySelectorAll('.modal.show');
        allModals.forEach(modal => {
          modal.classList.remove('show');
          modal.style.display = 'none';
          modal.setAttribute('aria-hidden', 'true');
        });
        
      } catch (e) {
        console.error('Backdrop temizleme hatası:', e);
      }
    },
    editContract(id) {
      apiClient.get(`/contract/${id}`).then(res => {
        const contract = this.mapContractFromBackend(res.data);
        this.currentCompanyId = res.data.companyid;
        this.contractItems = {
          ...contract,
          company: {
            id: res.data.companyid
          }
        };
        this.contractId = id;
        this.contractDisplay = true;
        this.selectedPage = { value: 0, pageName: 'contract', visibleName: 'Sözleşme' };
      }).catch(error => {
        console.error("Sözleşme verisi alınamadı:", error);
      });
    },
    save() {
      if (typeof this.contractItems.company === 'number') {
        this.contractItems.company = { id: this.contractItems.company };
      }
      const payload = {
        selectedPersonal: [],
        contractItems: this.mapContractToBackend(this.contractItems)
      };
      const url = this.contractId ? `/contract/${this.contractId}` : '/contract';
      const method = this.contractId ? 'put' : 'post';
      
      // Yükleme durumunu başlat
      this.isLoading = true;
      
      apiClient[method](url, payload).then(res => {
        const contractId = res?.data?.id;
        if (!contractId) {
          alert("Sözleşme ID alınamadı!");
          this.isLoading = false;
          return;
        }
        this.contractId = contractId;
        this.selectedPersonal = [];
        this.selectedPage = { value: 1, pageName: 'personal', visibleName: 'Personel' };
        this.getContractList();
        // contractItems'ı resetleme - sekme değişikliklerinde veri kaybına neden oluyor
        // Yükleme durumunu kapat
        this.isLoading = false;
      }).catch(error => {
        console.error("Sözleşme kaydı sırasında hata:", error);
        alert(this.parseError(error));
        // Hata durumunda da yükleme durumunu kapat
        this.isLoading = false;
      });
    },
    getContractList() {
      apiClient.get("/contract").then(res => {
        // Backend'den gelen ham veriyi logla
        console.log('=== BACKEND\'DEN GELEN HAM VERİ ===');
        if (res.data && res.data.length > 0) {
          const firstContract = res.data[0];
          console.log('İlk sözleşme (ham veri):', firstContract);
          console.log('Tüm anahtarlar (ham veri):', Object.keys(firstContract));
          // deletedAt ile ilgili tüm olası alanları kontrol et
          Object.keys(firstContract).forEach(key => {
            if (key.toLowerCase().includes('deleted') || key.toLowerCase().includes('delete')) {
              console.log(`  - ${key}:`, firstContract[key]);
            }
          });
        }
        
        // Backend'den gelen veriyi normalize et (canlı ortam için)
        this.contractsData = res.data.map(contract => {
          // Yeni bir obje oluştur
          const normalizedContract = {};
          
          // Tüm alanları kopyala
          Object.keys(contract).forEach(key => {
            normalizedContract[key] = contract[key];
          });
          
          // deletedAt alanını bul ve normalize et - tüm olası formatları kontrol et
          let deletedAtValue = null;
          
          // Önce standart alan isimlerini kontrol et
          // Backend zaten normalize ediyor, bu yüzden önce deletedAt'i kontrol et
          if (contract.deletedAt !== undefined) {
            // Backend'den gelen deletedAt değerini olduğu gibi kullan (null olabilir)
            deletedAtValue = contract.deletedAt;
          } else if (contract.deleted_at !== undefined) {
            deletedAtValue = contract.deleted_at;
          } else if (contract.deletedat !== undefined) {
            deletedAtValue = contract.deletedat;
          } else if (contract.contractDeletedAt !== undefined) {
            deletedAtValue = contract.contractDeletedAt;
          } else {
            // Eğer standart alanlar yoksa, tüm anahtarları tara
            Object.keys(contract).forEach(key => {
              const lowerKey = key.toLowerCase();
              if (lowerKey.includes('deleted') && (lowerKey.includes('at') || lowerKey.includes('date'))) {
                const value = contract[key];
                if (value !== undefined) {
                  deletedAtValue = value;
                  console.log(`deletedAt bulundu - key: ${key}, value:`, value);
                }
              }
            });
          }
          
          // Her durumda deletedAt olarak set et
          // null ise null, değer varsa değer (boş string kontrolü yapmıyoruz, null kontrolü yeterli)
          normalizedContract.deletedAt = deletedAtValue !== undefined ? deletedAtValue : null;
          
          return normalizedContract;
        });
        
        // Debug: Normalize edilmiş veriyi kontrol et
        console.log('=== NORMALIZE EDİLMİŞ VERİ ===');
        this.contractsData.forEach((contract, index) => {
          const deletedAt = contract.deletedAt;
          // deleted_at null ise Aktif, değilse Pasif
          const isActive = (deletedAt === null || deletedAt === undefined || deletedAt === '');
          const status = isActive ? 'AKTIF' : 'PASIF';
          if (index < 5) { // İlk 5 sözleşmeyi detaylı logla
            console.log(`Sözleşme ${index + 1} - ID: ${contract.id}, Name: ${contract.contractname || contract.contractName}, Status: ${status}`);
            console.log(`  - deletedAt (normalized):`, deletedAt);
            console.log(`  - deletedAt type:`, typeof deletedAt);
            console.log(`  - deletedAt === null:`, deletedAt === null);
            console.log(`  - deletedAt === undefined:`, deletedAt === undefined);
            console.log(`  - isActive:`, isActive);
          }
        });
        
        // Pasif sözleşmeleri kontrol et (deletedAt null değilse pasif)
        const passiveContracts = this.contractsData.filter(c => {
          const deletedAt = c.deletedAt;
          return deletedAt !== null && deletedAt !== undefined && deletedAt !== '';
        });
        console.log('Pasif sözleşme sayısı:', passiveContracts.length);
        console.log('Aktif sözleşme sayısı:', this.contractsData.length - passiveContracts.length);
      }).catch(error => {
        console.error('Sözleşme listesi alınırken hata:', error);
      });
    },

    // Backend hata mesajlarını detaylı olarak parse etme
    parseError(error) {
      if (error.response && error.response.data) {
        const errorData = error.response.data;

        // Sözleşme numarası duplicate hatası
        if (errorData.message && errorData.message.includes('contractnumber')) {
          return `Sözleşme numarası "${this.contractItems.contractNumber}" daha önce kullanılmış. Lütfen farklı bir sözleşme numarası giriniz.`;
        }

        // Duplicate key hatası
        if (errorData.message && errorData.message.includes('duplicate key')) {
          if (errorData.message.includes('contractnumber')) {
            return `Sözleşme numarası "${this.contractItems.contractNumber}" sistemde zaten mevcut. Lütfen farklı bir numara kullanınız.`;
          }
          return 'Bu sözleşme no daha önce girilmiş. Lütfen bilgileri kontrol ediniz.';
        }

        // Validation hataları
        if (errorData.errors && Array.isArray(errorData.errors)) {
          return errorData.errors.map(err => err.message || err).join(', ');
        }

        // Genel hata mesajı varsa
        if (errorData.message) {
          return errorData.message;
        }

        // Error string olarak gelmişse
        if (typeof errorData === 'string') {
          return errorData;
        }
      }

      // HTTP status kodlarına göre mesajlar
      if (error.response) {
        switch (error.response.status) {
          case 400:
            return 'Girilen bilgiler geçersiz. Lütfen tüm alanları kontrol ediniz.';
          case 409:
            return `Sözleşme numarası "${this.contractItems.contractNumber}" daha önce kullanılmış. Lütfen farklı bir numara giriniz.`;
          case 422:
            return 'Girilen veriler doğrulama kurallarına uymuyor. Lütfen bilgileri kontrol ediniz.';
          case 500:
            return 'Sunucu hatası oluştu. Lütfen daha sonra tekrar deneyiniz.';
          default:
            return `Beklenmeyen bir hata oluştu (${error.response.status}). Lütfen sistem yöneticisi ile iletişime geçiniz.`;
        }
      }

      // Network hatası
      if (error.code === 'NETWORK_ERROR') {
        return 'Ağ bağlantısı hatası. Lütfen internet bağlantınızı kontrol ediniz.';
      }

      // Genel hata
      return 'Sözleşme kaydedilirken beklenmeyen bir hata oluştu. Lütfen tekrar deneyiniz.';
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
      }
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    resetPagination() {
      this.currentPage = 1;
    },
    ensureCurrentPageInRange() {
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
      }
    }
  }
};
</script>
<style scoped>
/* Mevcut stilleriniz... */
.page-list {
  display: flex;
  justify-content: center;
  gap: 50px;
  margin-bottom: 30px;
}
.page-item {
  padding: 15px 25px;
  cursor: pointer;
  position: relative;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
}
.page-item::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 3px;
  background-color: #ddd;
  bottom: -4px;
  left: 0;
  transition: width 0.3s ease;
}
.page-item:hover::after {
  width: 100%;
}
.active::after {
  background-color: #007bff;
  width: 100%;
}
.btn:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}
button[disabled]:hover:after {
  content: attr(title);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px 10px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  margin-bottom: 5px;
}
.status-active {
  color: green;
  font-weight: bold;
}
.status-passive {
  color: red;
  font-weight: bold;
}
.sortable-header {
  cursor: pointer;
  user-select: none;
}
.sortable-header:hover {
  background-color: #f8f9fa;
}

/* Modal içindeki checkboxlar için stiller */
.modal-body .form-check {
  margin-bottom: 0.75rem;
}
.modal-body .form-check-label {
  cursor: pointer;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 15px;
  flex-wrap: wrap;
}
.pagination button {
  padding: 8px 12px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #fff;
  min-width: 100px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.pagination span {
  font-weight: 500;
  color: #344767;
}

/* Durum filtresi için stiller */
.form-select {
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 6 7 7 7-7'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

/* Responsive düzenlemeler */
@media (max-width: 768px) {
  .col-md-3, .col-md-2, .col-md-7 {
    margin-bottom: 0.5rem;
  }
}

/* Yükleme Overlay Stilleri */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  background-color: white;
  padding: 30px 50px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.loading-content p {
  margin: 0;
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

/* Actions butonları için hizalama */
.actions-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.25rem;
}
</style>
